// AdminPanel.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';          // <-- NEW: link helper
import axios from 'axios';
import './AdminPanel.css';

// Helper: Render a thumbnail preview for a single file path.
const renderFilePreview = (filePath) => {
  if (/\.(png|jpe?g|gif)$/i.test(filePath)) {
    return (
      <img
        src={`http://121.52.154.120:3001${filePath}`}
        alt="Attachment"
        style={{ width: '80px', height: 'auto' }}
      />
    );
  }
  if (filePath.toLowerCase().endsWith('.pdf')) {
    return <span style={{ fontSize: '12px' }}>PDF</span>;
  }
  if (filePath.toLowerCase().endsWith('.doc') || filePath.toLowerCase().endsWith('.docx')) {
    return <span style={{ fontSize: '12px' }}>DOC</span>;
  }
  if (filePath.toLowerCase().endsWith('.ppt') || filePath.toLowerCase().endsWith('.pptx')) {
    return <span style={{ fontSize: '12px' }}>PPT</span>;
  }
  return <span style={{ fontSize: '12px' }}>File</span>;
};

// Helper: Truncate text to a maximum length.
const truncateText = (text, maxLength) => {
  if (!text) return '';
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};

const AdminPanel = () => {
  // -------------- Data States --------------
  const [sliderImages, setSliderImages] = useState([]);
  const [newsEvents, setNewsEvents] = useState([]);
  const [admissions, setAdmissions] = useState([]);
  const [updates, setUpdates] = useState([]);

  // -------------- Upload Form States --------------
  // Slider Images (single file, field "image")
  const [image, setImage] = useState(null);
  const [caption, setCaption] = useState('');
  const [detail, setDetail] = useState('');

  // News Events (multiple files, field "files")
  const [newsTitle, setNewsTitle] = useState('');
  const [newsDescription, setNewsDescription] = useState('');
  const [newsFiles, setNewsFiles] = useState([]);

  // Admissions (Research & Innovations) (multiple files, field "files")
  const [admissionsTitle, setAdmissionsTitle] = useState('');
  const [admissionsDescription, setAdmissionsDescription] = useState('');
  const [admissionsFiles, setAdmissionsFiles] = useState([]);

  // Updates (multiple files, field "files")
  const [updateTitle, setUpdateTitle] = useState('');
  const [updateDescription, setUpdateDescription] = useState('');
  const [updateFiles, setUpdateFiles] = useState([]);

  // -------------- Data Fetching --------------
  useEffect(() => {
    fetchSliderImages();
    fetchNewsEvents();
    fetchAdmissions();
    fetchUpdates();
  }, []);

  const fetchSliderImages = async () => {
    try {
      const response = await axios.get('http://121.52.154.120:3001/api/slider-images');
      setSliderImages(response.data);
    } catch (error) {
      console.error('Failed to fetch slider images:', error.message);
    }
  };

  const fetchNewsEvents = async () => {
    try {
      const response = await axios.get('http://121.52.154.120:3001/api/news-events');
      setNewsEvents(response.data);
    } catch (error) {
      console.error('Failed to fetch news events:', error.message);
    }
  };

  const fetchAdmissions = async () => {
    try {
      const response = await axios.get('http://121.52.154.120:3001/api/admissions');
      setAdmissions(response.data);
    } catch (error) {
      console.error('Failed to fetch admissions:', error.message);
    }
  };

  const fetchUpdates = async () => {
    try {
      const response = await axios.get('http://121.52.154.120:3001/api/updates');
      setUpdates(response.data);
    } catch (error) {
      console.error('Failed to fetch updates:', error.message);
    }
  };

  // -------------- Upload Handlers --------------
  // Slider Images upload (field "image")
  const handleImageUpload = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('image', image);
      formData.append('caption', caption);
      formData.append('detail', detail);
      await axios.post('http://121.52.154.120:3001/api/slider-images', formData);
      fetchSliderImages();
      setImage(null);
      setCaption('');
      setDetail('');
    } catch (error) {
      console.error('Error uploading slider image:', error.message);
    }
  };

  // News Events upload (field "files")
  const handleNewsEventAdd = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('title', newsTitle);
      formData.append('description', newsDescription);
      for (let i = 0; i < newsFiles.length; i++) {
        formData.append('files', newsFiles[i]);
      }
      await axios.post('http://121.52.154.120:3001/api/news-events', formData);
      fetchNewsEvents();
      setNewsTitle('');
      setNewsDescription('');
      setNewsFiles([]);
    } catch (error) {
      console.error('Error adding news event:', error.message);
    }
  };

  // Admissions upload (field "files")
  const handleAdmissionsAdd = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('title', admissionsTitle);
      formData.append('description', admissionsDescription);
      for (let i = 0; i < admissionsFiles.length; i++) {
        formData.append('files', admissionsFiles[i]);
      }
      await axios.post('http://121.52.154.120:3001/api/admissions', formData);
      fetchAdmissions();
      setAdmissionsTitle('');
      setAdmissionsDescription('');
      setAdmissionsFiles([]);
    } catch (error) {
      console.error('Error adding admissions event:', error.message);
    }
  };

  // Updates upload (field "files")
  // For the section "Admissions and General Circulars", send category as "NEWS AND UPDATES"
  const handleUpdateAdd = async (e, category) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('title', updateTitle);
      formData.append('description', updateDescription);
      formData.append('category', category === 'Admissions and General Circulars' ? 'NEWS AND UPDATES' : category);
      for (let i = 0; i < updateFiles.length; i++) {
        formData.append('files', updateFiles[i]);
      }
      await axios.post('http://121.52.154.120:3001/api/updates', formData);
      fetchUpdates();
      setUpdateTitle('');
      setUpdateDescription('');
      setUpdateFiles([]);
    } catch (error) {
      console.error('Error adding update:', error.message);
    }
  };

  // -------------- Delete Handlers --------------
  const handleDeleteSliderImage = async (id) => {
    try {
      await axios.delete(`http://121.52.154.120:3001/api/slider-images/${id}`);
      fetchSliderImages();
    } catch (error) {
      console.error('Error deleting slider image:', error.message);
    }
  };

  const handleDeleteNewsEvent = async (id) => {
    try {
      await axios.delete(`http://121.52.154.120:3001/api/news-events/${id}`);
      fetchNewsEvents();
    } catch (error) {
      console.error('Error deleting news event:', error.message);
    }
  };

  const handleDeleteAdmissions = async (id) => {
    try {
      await axios.delete(`http://121.52.154.120:3001/api/admissions/${id}`);
      fetchAdmissions();
    } catch (error) {
      console.error('Error deleting admissions event:', error.message);
    }
  };

  const handleDeleteUpdate = async (id) => {
    try {
      await axios.delete(`http://121.52.154.120:3001/api/updates/${id}`);
      fetchUpdates();
    } catch (error) {
      console.error('Error deleting update:', error.message);
    }
  };

  // -------------- Rendering Updates by Category --------------
  // For table view categories, we show a thumbnail and list all attachments.
  const renderAllAttachments = (update) => {
    if (!update.attachments) return null;
    try {
      const arr = JSON.parse(update.attachments);
      if (arr.length === 0) return null;
      return (
        <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
          {arr.map((filePath, idx) => (
            <a
              key={idx}
              href={`http://121.52.154.120:3001${filePath}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'inline-block' }}
            >
              {renderFilePreview(filePath)}
            </a>
          ))}
        </div>
      );
    } catch (e) {
      return null;
    }
  };

  // For table view, if update.imageUrl exists, use that as the primary thumbnail.
  const renderUpdateThumbnail = (update) => {
    if (update.imageUrl) {
      return (
        <img
          src={`http://121.52.154.120:3001${update.imageUrl}`}
          alt={update.title}
          style={{ width: '80px' }}
        />
      );
    }
    return 'No Image';
  };

  // Define table view categories.
  // Note: For "Admissions and General Circulars" header, we filter by updates with category "NEWS AND UPDATES"
  const tableCategories = [
    'EXAMINATIONS & RESULTS',
    'POSTGRADUATE STUDIES & RESEARCH Updates',
    'TENDER NOTICES',
    'Admissions and General Circulars'
  ];

  // The remaining update categories will be rendered as a list with truncated descriptions.
  const listCategories = [
    'Upcoming Events',
    'Student events and Sports',
    "Students' Consultative Bureau updates"
  ];

  return (
    <div className="page-container">
      {/* ---------- NEW LINK TO FACULTY LIST ---------- */}
      <div style={{ marginBottom: '10px' }}>
        <Link to="/admin/faculty-list" className="faculty-link">
          👉 Manage Faculty Directory
        </Link>
      </div>

      <h1>Admin Panel</h1>

      {/* ---------------- Slider Images Section ---------------- */}
      <section className="upload-section">
        <h2>Slider Images</h2>
        <form onSubmit={handleImageUpload}>
          <input type="file" onChange={(e) => setImage(e.target.files[0])} />
          <input type="text" placeholder="Caption" value={caption} onChange={(e) => setCaption(e.target.value)} />
          <input type="text" placeholder="Detail" value={detail} onChange={(e) => setDetail(e.target.value)} />
          <button type="submit">Upload Image</button>
        </form>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Thumbnail</th>
                <th>Caption</th>
                <th>Detail</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {sliderImages.map((img) => (
                <tr key={img.id}>
                  <td><img src={img.imageUrl} alt={img.caption} style={{ width: '100px' }} /></td>
                  <td>{img.caption}</td>
                  <td>{img.detail}</td>
                  <td><button onClick={() => handleDeleteSliderImage(img.id)}>Delete</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* ---------------- News Events Section ---------------- */}
      <section className="upload-section">
        <h2>News and Events</h2>
        <form onSubmit={handleNewsEventAdd}>
          <input type="text" placeholder="Title" value={newsTitle} onChange={(e) => setNewsTitle(e.target.value)} />
          <textarea placeholder="Description" value={newsDescription} onChange={(e) => setNewsDescription(e.target.value)} />
          <input type="file" multiple onChange={(e) => setNewsFiles(e.target.files)} />
          <button type="submit">Add Update</button>
        </form>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Image</th>
                <th>Title</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {newsEvents.map((event) => (
                <tr key={event.id}>
                  <td><img src={event.imageUrl} alt={event.title} style={{ width: '100px' }} /></td>
                  <td>{event.title}</td>
                  <td>{event.description}</td>
                  <td><button onClick={() => handleDeleteNewsEvent(event.id)}>Delete</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* ---------------- Admissions (Research and Innovations) Section ---------------- */}
      <section className="upload-section">
        <h2>Research and Innovations</h2>
        <form onSubmit={handleAdmissionsAdd}>
          <input type="text" placeholder="Title" value={admissionsTitle} onChange={(e) => setAdmissionsTitle(e.target.value)} />
          <textarea placeholder="Description" value={admissionsDescription} onChange={(e) => setAdmissionsDescription(e.target.value)} />
          <input type="file" multiple onChange={(e) => setAdmissionsFiles(e.target.files)} />
          <button type="submit">Add Update</button>
        </form>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Image / Description</th>
                <th>Title</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {admissions.map((event) => (
                <tr key={event.id}>
                  <td>
                    {event.imageUrl ? (
                      <img
                        src={`http://121.52.154.120:3001${event.imageUrl}`}
                        alt={event.title}
                        style={{ width: '100px', height: 'auto' }}
                      />
                    ) : (
                      <p>{event.description || 'No description available'}</p>
                    )}
                  </td>
                  <td>{event.title}</td>
                  <td>{event.description}</td>
                  <td>
                    <button onClick={() => handleDeleteAdmissions(event.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* ---------------- Update Upload Forms ---------------- */}
      <section className="upload-section">
        <h2>EXAMINATIONS & RESULTS</h2>
        <form onSubmit={(e) => handleUpdateAdd(e, 'EXAMINATIONS & RESULTS')}>
          <input type="text" placeholder="Title" value={updateTitle} onChange={(e) => setUpdateTitle(e.target.value)} required />
          <textarea placeholder="Description" value={updateDescription} onChange={(e) => setUpdateDescription(e.target.value)} required />
          <input type="file" multiple onChange={(e) => setUpdateFiles(e.target.files)} />
          <button type="submit">Add Update</button>
        </form>
      </section>

      <section className="upload-section">
        <h2>POSTGRADUATE STUDIES & RESEARCH Updates</h2>
        <form onSubmit={(e) => handleUpdateAdd(e, 'POSTGRADUATE STUDIES & RESEARCH Updates')}>
          <input type="text" placeholder="Title" value={updateTitle} onChange={(e) => setUpdateTitle(e.target.value)} required />
          <textarea placeholder="Description" value={updateDescription} onChange={(e) => setUpdateDescription(e.target.value)} required />
          <input type="file" multiple onChange={(e) => setUpdateFiles(e.target.files)} />
          <button type="submit">Add Update</button>
        </form>
      </section>

      <section className="upload-section">
        <h2>TENDER NOTICES</h2>
        <form onSubmit={(e) => handleUpdateAdd(e, 'TENDER NOTICES')}>
          <input type="text" placeholder="Title" value={updateTitle} onChange={(e) => setUpdateTitle(e.target.value)} required />
          <textarea placeholder="Description" value={updateDescription} onChange={(e) => setUpdateDescription(e.target.value)} required />
          <input type="file" multiple onChange={(e) => setUpdateFiles(e.target.files)} />
          <button type="submit">Add Update</button>
        </form>
      </section>

      {/* For "Admissions and General Circulars", send category as "NEWS AND UPDATES" */}
      <section className="upload-section">
        <h2>Admissions and General Circulars</h2>
        <form onSubmit={(e) => handleUpdateAdd(e, 'Admissions and General Circulars')}>
          <input type="text" placeholder="Title" value={updateTitle} onChange={(e) => setUpdateTitle(e.target.value)} required />
          <textarea placeholder="Description" value={updateDescription} onChange={(e) => setUpdateDescription(e.target.value)} required />
          <input type="file" multiple onChange={(e) => setUpdateFiles(e.target.files)} />
          <button type="submit">Add Update</button>
        </form>
      </section>

      <section className="upload-section">
        <h2>Upcoming Events</h2>
        <form onSubmit={(e) => handleUpdateAdd(e, 'Upcoming Events')}>
          <input type="text" placeholder="Title" value={updateTitle} onChange={(e) => setUpdateTitle(e.target.value)} required />
          <textarea placeholder="Description" value={updateDescription} onChange={(e) => setUpdateDescription(e.target.value)} required />
          <input type="file" multiple onChange={(e) => setUpdateFiles(e.target.files)} />
          <button type="submit">Add Update</button>
        </form>
      </section>

      <section className="upload-section">
        <h2>Student Events and Sports</h2>
        <form onSubmit={(e) => handleUpdateAdd(e, 'Student events and Sports')}>
          <input type="text" placeholder="Title" value={updateTitle} onChange={(e) => setUpdateTitle(e.target.value)} required />
          <textarea placeholder="Description" value={updateDescription} onChange={(e) => setUpdateDescription(e.target.value)} required />
          <input type="file" multiple onChange={(e) => setUpdateFiles(e.target.files)} />
          <button type="submit">Add Update</button>
        </form>
      </section>

      <section className="upload-section">
        <h2>Students' Consultative Bureau Updates</h2>
        <form onSubmit={(e) => handleUpdateAdd(e, "Students' Consultative Bureau updates")}>
          <input type="text" placeholder="Title" value={updateTitle} onChange={(e) => setUpdateTitle(e.target.value)} required />
          <textarea placeholder="Description" value={updateDescription} onChange={(e) => setUpdateDescription(e.target.value)} required />
          <input type="file" multiple onChange={(e) => setUpdateFiles(e.target.files)} />
          <button type="submit">Add Update</button>
        </form>
      </section>

      {/* ---------------- Rendering Updates by Category (Table View) ---------------- */}
      {tableCategories.map((category) => {
        // For "Admissions and General Circulars", filter by "NEWS AND UPDATES"
        const filterCategory = category === 'Admissions and General Circulars' ? 'NEWS AND UPDATES' : category;
        return (
          <section key={category} className="render-section">
            <h2>{category}</h2>
            <table className="updates-table" style={{ fontSize: '12px' }}>
              <thead>
                <tr>
                  <th>Thumbnail</th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Attachments</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {updates
                  .filter((u) => u.category === filterCategory)
                  .map((update) => (
                    <tr key={update.id}>
                      <td>{renderUpdateThumbnail(update)}</td>
                      <td>{update.title}</td>
                      <td>{update.description}</td>
                      <td>{renderAllAttachments(update)}</td>
                      <td>
                        <button className="delete" onClick={() => handleDeleteUpdate(update.id)}>
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                {updates.filter((u) => u.category === filterCategory).length === 0 && (
                  <tr>
                    <td colSpan="5">No updates available for {category}.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </section>
        );
      })}

      {/* ---------------- Rendering Updates by Category (List View) ---------------- */}
      {listCategories.map((category) => (
        <section key={category} className="render-section">
          <h2>{category}</h2>
          <div className="updates-list">
            {updates
              .filter((u) => u.category === category)
              .map((update) => (
                <div key={update.id} className="update-item2">
                  <h3>{update.title}</h3>
                  {update.imageUrl ? (
                    <img
                      src={`http://121.52.154.120:3001${update.imageUrl}`}
                      alt={update.title}
                      className="update-image"
                    />
                  ) : (
                    <p>No Image Available</p>
                  )}
                  <p>{truncateText(update.description, 300)}</p>
                  <button className="delete" onClick={() => handleDeleteUpdate(update.id)}>
                    Delete
                  </button>
                </div>
              ))}
            {updates.filter((u) => u.category === category).length === 0 && (
              <p className="placeholder">No updates available for {category}.</p>
            )}
          </div>
        </section>
      ))}
    </div>
  );
};

export default AdminPanel;
